"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadFromWindowName = exports.saveToWindowName = exports.join = exports.split = void 0;
const codec_1 = require("@47ng/codec");
const randomBytes = (length) => {
    if (typeof window === 'undefined') {
        const crypto = require('crypto'); // Node.js crypto module
        return crypto.randomBytes(length);
    }
    else {
        return window.crypto.getRandomValues(new Uint8Array(length));
    }
};
exports.split = (secret) => {
    const buff = codec_1.utf8.encode(secret);
    const rand1 = randomBytes(buff.length);
    const rand2 = new Uint8Array(rand1); // Make a copy
    for (const i in buff) {
        rand2[i] = rand2[i] ^ buff[i];
    }
    return [codec_1.b64.encode(rand1), codec_1.b64.encode(rand2)];
};
exports.join = (a, b) => {
    if (a.length !== b.length) {
        return null;
    }
    const aBuff = codec_1.b64.decode(a);
    const bBuff = codec_1.b64.decode(b);
    const output = new Uint8Array(aBuff.length);
    for (const i in output) {
        output[i] = aBuff[i] ^ bBuff[i];
    }
    return codec_1.utf8.decode(output);
};
// --
const loadObjectFromWindowName = () => {
    if (!window.top.name || window.top.name === '') {
        return {};
    }
    try {
        return JSON.parse(window.top.name);
    }
    catch (_a) { }
    return {};
};
exports.saveToWindowName = (name, data) => {
    const obj = loadObjectFromWindowName();
    obj[name] = data;
    window.top.name = JSON.stringify(obj);
};
exports.loadFromWindowName = (name) => {
    const saved = loadObjectFromWindowName();
    if (!(name in saved)) {
        return null;
    }
    const { [name]: out, ...safe } = saved;
    const json = JSON.stringify(safe);
    window.top.name = json === '{}' ? '' : json;
    return out || null;
};
